function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_MESSAGESBYGROUPID_REQUEST = "GET_MESSAGESBYGROUPID_REQUEST";
export var GET_MESSAGESBYGROUPID_SUCCESS = "GET_MESSAGESBYGROUPID_SUCCESS";
export var GET_MESSAGESBYGROUPID_FAILURE = "GET_MESSAGESBYGROUPID_FAILURE";
export var RESET_GET_MESSAGESBYGROUPID = "RESET_GET_MESSAGESBYGROUPID";
export var fetchMessagesByGroupId = function fetchMessagesByGroupId(groupId, maxId, count) {
  var queryString = urlSearchParams({
    groupId: groupId,
    maxId: maxId,
    count: count
  });
  return _defineProperty({
    groupId: groupId,
    maxId: maxId,
    count: count
  }, CALL_API, {
    types: [GET_MESSAGESBYGROUPID_REQUEST, GET_MESSAGESBYGROUPID_SUCCESS, GET_MESSAGESBYGROUPID_FAILURE],
    endpoint: "messages/search/findByGroupId".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};
export var PUSH_MESSAGE = "PUSH_MESSAGE";
export var pushMessage = function pushMessage(message, authUserId) {
  return {
    message: message,
    authUserId: authUserId,
    type: PUSH_MESSAGE
  };
};